import React, { useEffect, useState } from "react";

const formatTime = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  let timeString = "";
  if (hours > 0) timeString += `${hours}h `;
  if (minutes > 0 || hours > 0) timeString += `${minutes}m`;

  return timeString || "0m";
};

const calculateTimeToNextMidnight = () => {
  const now = new Date();
  const nextDay = new Date(now);

  nextDay.setHours(0, 0, 0, 0);

  if (now.getTime() > nextDay.getTime()) {
    nextDay.setDate(now.getDate() + 1);
  }

  return (nextDay.getTime() - now.getTime()) / 1000;
};

const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeToNextMidnight());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => (prev > 1 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return <div>{formatTime(timeLeft)}</div>;
};

export default CountdownTimer;
